/**
 * simplex router
 */

import { factories } from '@strapi/strapi';

export default factories.createCoreRouter('plugin::telegram-bot.telegram-user-activity');
